import {
  Comment as CommunityComment,
  CommentItem,
  RemixComment as CommunityRemixComment,
} from 'types/comment';
import styles from './CommentGroup.module.css';
import Comment from './Comment';
import { CommunityShotItem } from 'types/community';
import RemixComment from './RemixComment';

type Props = {
  commentItem: CommentItem;
  shotItem: CommunityShotItem;
  repliesEnabled: Boolean;
  targetCommentId?: number;
};

// Junk name, need better, there's probably a passthrough class or something for this.
export default function CommentGroup(props: Props) {
  function commentComponent() {
    if (props.commentItem.type === 'COMMENT') {
      return (
        <Comment
          shotItem={props.shotItem}
          comment={props.commentItem.item as CommunityComment}
          repliesEnabled={props.repliesEnabled}
          targetCommentId={props.targetCommentId}
        />
      );
    } else if (props.commentItem.type === 'REMIX') {
      return (
        <RemixComment remix={props.commentItem.item as CommunityRemixComment} />
      );
    } else {
      return null;
    }
  }

  return <div className={styles.CommentGroup}>{commentComponent()}</div>;
}
